import React from 'react';
import MonthRecordingsUI from './MonthRecordingsUI';

const March = () => <MonthRecordingsUI month="March" />;

export default March;
